import * as React from 'react';

/**
 * Full-width "FEATURED" ribbon used on exhibitor cards, profiles, map popovers, etc.
 *
 * Implementation notes (Maps exhibitor list fix):
 * - Previously wrapped in react-redux connect() and spread {...props} onto the root <div>. That forwarded
 *   the `main` object (and other props) as invalid DOM attributes and caused stray layout / text issues.
 * - Styling is intentionally in ViewClient.css (.featured-label): solid fallback color plus
 *   var(--secondaryColor, #FF7F27) so the bar stays visible when the CSS variable is not defined for a show.
 */
function FeaturedLabel(props) {
  const { moreClass = '', className = '', style, children } = props;

  return (
    <div
      className={`featured-label ${moreClass} ${className}`.trim()}
      style={style}
    >
      {children ?? 'FEATURED'}
    </div>
  );
}

export default FeaturedLabel;
